import { z } from 'zod';
import { ExternalContactSchema } from '../../entities/external-contact/external-contact.schema';
import { optionalEmailSchema } from '../../shared/email.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Add External Contact Request Schema
 * POST /api/v2/external-contacts
 */ export const AddExternalContactRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    email: optionalEmailSchema(),
    description: z.string().optional(),
    type: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
/**
 * Add External Contact Response Schema
 * POST /api/v2/external-contacts
 */ export const AddExternalContactResponseSchema = z.object({
    data: ExternalContactSchema
});

//# sourceMappingURL=add-external-contact.schema.js.map